import { Text } from "@react-three/drei";
import { Box } from "@react-three/flex";
import React from "react";
import { textMeshMaterial } from "../XRImagePop";

const SmallTextLabel = (props: { children?: string; displayed?: boolean }) => {
  return (
    <Box marginTop={0.5} width={"100%"} centerAnchor visible={props.displayed}>
      <Text
        fontStyle="italic"
        fontWeight={400}
        fontSize={0.9}
        maxWidth={20}
        material={textMeshMaterial}
        renderOrder={3}
      >
        {props.children}
      </Text>
    </Box>
  );
};

export default SmallTextLabel;
